@if (show()) {
  <div
    class="tour-progress-content card-body"
    [class.collapsed]="isCollapsed()"
  >
    <div class="d-flex justify-content-between align-items-center">
      <h4 class="mb-0">Get Started</h4>
      @if (tourComplete()) {
        <mop-button
          class="dismiss-button"
          size="sm"
          type="primary"
          text="Finish"
          (click)="endTour()"
        ></mop-button>
      } @else {
        <mop-button
          class="dismiss-button"
          size="sm"
          type="secondary"
          text="Dismiss"
          (click)="dismissTour()"
        ></mop-button>
      }
    </div>
    <ul class="list-unstyled mb-0">
      @for (itinerary of itineraries(); track $index) {
        <li
          class="checklist-item"
          [class.completed]="itinerary.isCompleted"
          (click)="startItinerary(itinerary)"
        >
          <div class="checkbox-container">
            <i class="modus-icons notranslate check-icon" aria-hidden="true"
              >check</i
            >
          </div>
          <label class="form-check-label me-3">{{ itinerary.name }}</label>
          <mop-icon
            class="question-icon"
            name="question"
            size="20"
            outlined="true"
          ></mop-icon>
        </li>
      }
    </ul>
  </div>

  <button
    type="button"
    class="btn btn-warning collapse-btn position-absolute m-2 d-flex align-items-center justify-content-center"
    data-tour-poi="tourProgressButton"
    [class.rounded-pill]="isCollapsed()"
    [class.btn-light]="!isCollapsed()"
    [class.rounded-circle]="!isCollapsed()"
    (click)="toggleCollapsed()"
  >
    @if (isCollapsed()) {
      <span class="fw-bold px-2" style="font-size: 1rem">Help</span>
      <mop-icon name="help" outlined="true"></mop-icon>
    } @else {
      <mop-icon name="expand-more"></mop-icon>
    }
  </button>
}
